import {
    HistoricoClienteInterface,
    HistoricoClienteInterfaceResponse,
    HistoricoInterface,
    ICasoAtividade,
    ICasoAtividadeResponse,
    ILstInforVendasResponse,
} from "../../../Interfaces/Geral/Historicos/HistoricoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarHistoricosService(idCaso: number) {
    return Service(
        Axios.get<Array<HistoricoInterface>>(
            `/home/historico/listarhistorico?ID_CASO=${idCaso}`
        )
    );
}

export async function ExportarExcelGenericoService(
    requestBody: {
        ID_CASO: number;
        DS_USUARIO: string;
        DS_HISTORICO: string;
        DT_CADASTRO: string;
    }[]
) {
    return Service(
        Axios.post<Blob>(
            `/home/exportardocumentos/exportalexcelgenerico`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export async function ListarHistoricoClienteService(idConta: number) {
    return Service(
        Axios.get<Array<HistoricoClienteInterface>>(
            `/home/historico/listarhistoricocliente?ID_CONTA=${idConta}`
        )
    );
}

export async function ListarHistoricoUAUService(ID_CHAVE_ERP: string) {
    return Service(
        Axios.get<Array<HistoricoClienteInterfaceResponse>>(
            `/home/historico/listarhistoricoclienteuau?ID_CHAVE_ERP_CONTA=${ID_CHAVE_ERP}`
        )
    );
}

export async function CadastrarHistoricoService(
    requestBody: HistoricoInterface
) {
    return Service(
        Axios.post("/home/historico/cadastrarhistorico", requestBody)
    );
}

export async function MarcarHistoricoLidoService(
    idCasoHistorico: number,
    FL_LIDO: boolean
) {
    return Service(
        Axios.post(
            `/home/historico/marcarhistoricolido?idCasoHistorico=${idCasoHistorico}&FL_LIDO=${FL_LIDO}`
        )
    );
}

export async function AtualizarHistoricoService(
    requestBody: HistoricoInterface
) {
    return Service(
        Axios.put("/home/historico/atualizarhistorico", requestBody)
    );
}

export async function DeletarHistoricoService(ID_CASO_HISTORICO: number) {
    return Service(
        Axios.delete(
            `/home/historico/deletarhistorico?ID_CASO_HISTORICO=${ID_CASO_HISTORICO}`
        )
    );
}

export async function ListarCasoAtividadeService(ID_CASO_ATIVIDADE: number) {
    return Service(
        Axios.get(
            `/home/casoatividade/obtercasoatividade?ID_CASO_ATIVIDADE=${ID_CASO_ATIVIDADE}`
        )
    );
}

export async function UpdateCasoAtividadeService(requestBody: ICasoAtividade) {
    return Service(
        Axios.put(`/home/casoatividade/atualizarcasoatividade`, requestBody)
    );
}

export async function DeletarCasoAtividadeService(resquestBody: Array<number>) {
    return Service(
        Axios.delete(`/home/casoatividade/deletarcasoatividade`, {
            data: resquestBody,
        })
    );
}

export async function CadastrarCasoAtividadeService(
    requestBody: ICasoAtividade
) {
    return Service(
        Axios.post(`/home/casoatividade/cadastrarcasoatividade`, requestBody)
    );
}

export async function AtualizarCasoAtividadeService(
    requestBody: ICasoAtividade
) {
    return Service(
        Axios.put(`/home/casoatividade/atualizarcasoatividade`, requestBody)
    );
}

export async function ListarCasoAtividadeAgendaService(
    DT_INICIO: string,
    DT_FIM: string
) {
    return Service(
        Axios.get<Array<ICasoAtividadeResponse>>(
            `/home/casoatividade/listarcasoatividadeagenda?DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}`
        )
    );
}

export async function ListarCasoAtividadeFiltroService(
    Filtro: string,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Service(
        Axios.get<Array<ICasoAtividadeResponse>>(
            `/home/casoatividade/listarcasoatividadefiltro?Filtro=${Filtro}&DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}`
        )
    );
}

export async function ListaInformacoesVendasService(
    ID_EMPREENDIMENTO: number,
    DT_FIM: string,
    DT_INICIO: string
) {
    return Service(
        Axios.get<Array<ILstInforVendasResponse>>(
            `/home/casoatividade/listainformacoesvendas?ID_EMPREENDIMENTO=${ID_EMPREENDIMENTO}&DT_FIM=${DT_FIM}&DT_INICIO=${DT_INICIO}`
        )
    );
}
